/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScheduleAvailabilityItemDto = {
    /**
     * Availability window UUID
     */
    id: string;
    /**
     * Start time
     */
    startTime: string;
    /**
     * End time
     */
    endTime: string;
    /**
     * Supported session modes
     */
    modes: Array<'online' | 'client_location' | 'expert_location'>;
    /**
     * Slot status
     */
    status?: ScheduleAvailabilityItemDto.status;
};
export namespace ScheduleAvailabilityItemDto {
    /**
     * Slot status
     */
    export enum status {
        AVAILABLE = 'available',
        BOOKED = 'booked',
    }
}

